<template>
    <div class="construction"></div>
</template>

<script>
export default {
    data() {
        return {};
    },
};
</script>

<style lang="stylus" scoped>
.construction
  width 100%
  height 100%
  background url("./../../assets/images/default/construction.png") center no-repeat
  background-size 70%
</style>
